import { AppDispatch } from "../store";
import api, { API_PATHS } from "./api";
import { updateWorkTaskLockedForPlanning } from "../store/ganttChart";
import { setNotification } from "../store/toastNotifications";
import labels from "../utils/labels";

type LockTaskBody = {
  idWorkTask: number;
  lockedForPlanning: boolean;
};

class LockTaskService {
  static async toggleLock(
    idTask: number,
    currentLockedForPlanning: boolean,
    dispatch: AppDispatch,
  ): Promise<void> {
    const lockedForPlanning = !currentLockedForPlanning;
    const body: LockTaskBody = { idWorkTask: idTask, lockedForPlanning };

    dispatch(updateWorkTaskLockedForPlanning({ idTask, lockedForPlanning }));

    try {
      await api.post(API_PATHS.lockTask, body);
    } catch {
      dispatch(
        updateWorkTaskLockedForPlanning({
          idTask,
          lockedForPlanning: currentLockedForPlanning,
          isRollback: true,
        }),
      );
      dispatch(
        setNotification({
          message: labels.lockTaskError,
          type: "lock_task_failed",
        }),
      );
    }
  }
}

export default LockTaskService;
